import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import People from "@material-ui/icons/People";
import Public from "@material-ui/icons/Public";
import PublicTT from "@material-ui/icons/PublicTwoTone";
import Warning from "@material-ui/icons/Warning";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

// reactor
import User from "components/User";

// styles
import styles from "./styles";

class OrganizationDetail extends Component {
  static propTypes = {
    classes: PropTypes.object,
    close: PropTypes.func,
    organization: PropTypes.object,
    deleteOrganization: PropTypes.func,
    updateOrganization: PropTypes.func,
    getOrganizationUsers: PropTypes.func,
    deleteOrganizationUser: PropTypes.func,
    addUserToOrganization: PropTypes.func,
    admin: PropTypes.bool,
    joinOrganization: PropTypes.func,
    refresh: PropTypes.func,
    user: PropTypes.object,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    const { organization } = this.props;
    this.state = {
      ...organization,
      index: 0,
      inviteEmail: "",
      loading: false,
      organizationOrganizations: [],
      organizationApps: [],
      method: 0,
    };
    this.refresh(organization);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.refreshKey !== this.props.refreshKey) {
      this.init(nextProps.organization);
    }
  }

  init(organization) {
    //eslint-disable-line
    this.setState({
      ...organization,
      loading: false,
      inviteEmail: "",
      organizationOrganizations: [],
      organizationApps: [],
    });
    this.refresh(organization);
  }

  getStepContent(index) {
    const { classes, organization, deleteOrganizationUser, admin } = this.props;

    const {
      name,
      loading,
      users,
      inviteEmail,
      deleteValidation,
      token,
    } = this.state;

    switch (index) {
      case 0:
        return (
          <Grid container spacing={2} className={classes.step}>
            <Grid item xs={12}>
              <TextField
                id="name"
                fullWidth
                label="Name"
                className={classes.textField}
                value={name}
                onChange={this.handleChange("name")}
                onBlur={() => this.save("name")}
                onKeyPress={(e) => {
                  if (e.key === "Enter") this.save("name");
                }}
                disabled={loading}
              />
            </Grid>
            {admin ? (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.default}
                      onChange={() => {
                        this.state.default = !this.state.default; // eslint-disable-line
                        this.save("default");
                      }}
                      value="Default"
                    />
                  }
                  label="Default Group"
                />
              </Grid>
            ) : (
              []
            )}
            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary">
                Organization Token
              </Typography>
              <Typography>{token}</Typography>
              <Typography variant="caption" color="textSecondary">
                Share this token with new users, so they can sign up and
                directly join the organization.
              </Typography>
            </Grid>
          </Grid>
        );
      case 1:
        return (
          <Grid
            container
            spacing={2}
            className={classes.step}
            alignItems="center"
          >
            <Grid item xs={8}>
              <TextField
                id="inviteEmail"
                fullWidth
                label="Enter user's email"
                className={classes.textField}
                value={inviteEmail}
                onChange={this.handleChange("inviteEmail")}
                disabled={loading}
              />
            </Grid>
            <Grid item xs={4}>
              <Chip label="Send Invite" onClick={this.inviteUser.bind(this)} />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                {users &&
                  users.map((user) => (
                    <Grid item xs={12} key={`user_${user.id}`}>
                      <User
                        user={user}
                        deleteOrganizationUser={deleteOrganizationUser}
                        refresh={() => this.refresh(organization)}
                      />
                    </Grid>
                  ))}
              </Grid>
            </Grid>
          </Grid>
        );
      case 2:
        return (
          <Grid container spacing={2} className={classes.step}>
            <Grid item xs={12}>
              <Typography variant="h6">Delete</Typography>
              <Grid item xs={12}>
                <Typography>Enter the organization's name to delete</Typography>
                <TextField
                  id="email"
                  variant="filled"
                  fullWidth
                  label={`${name}`}
                  className={classes.textField}
                  value={deleteValidation}
                  onChange={this.handleChange("deleteValidation")}
                />
                <br />
                <br />
                <Button
                  variant="contained"
                  style={{
                    opacity: deleteValidation !== name ? 0.5 : 1,
                  }}
                  size="small"
                  disabled={deleteValidation !== name}
                  onClick={this.deleteOrganization.bind(this)}
                >
                  Delete Organization
                </Button>
              </Grid>
            </Grid>
          </Grid>
        );
      default:
        return (
          <Grid container>
            <Grid item>Unkown Step</Grid>
          </Grid>
        );
    }
  }

  handleCheckboxChange = (name) => (event) => {
    const { target } = event;
    const { checked } = target;

    this.setState({
      [name]: checked,
    });
  };

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;
    this.setState({
      [name]: value,
    });
  };

  async save(name, numeric) {
    const { updateOrganization, refresh, organization } = this.props;

    await updateOrganization(organization.id, {
      [name]: numeric ? Number(this.state[name]) : this.state[name],
    });

    this.setState({
      loading: false,
    });

    refresh();
  }

  async refresh(organization) {
    const { getOrganizationUsers } = this.props;
    this.setState({ loading: true });

    const resp = await getOrganizationUsers(organization.id);
    if (resp.success) {
      const users = resp.payload;
      this.setState({ users, loading: false });
    }
  }

  async deleteOrganization() {
    const { organization, deleteOrganization, close, refresh } = this.props;
    await deleteOrganization(organization.id);
    refresh();
    close();
  }

  async inviteUser() {
    const { addUserToOrganization, organization } = this.props;
    const { NotificationCenter } = this.context;
    const { inviteEmail } = this.state;
    await addUserToOrganization(organization.id, { inviteEmail });
    this.refresh(organization);
    this.setState({
      inviteEmail: "",
    });
    NotificationCenter.sweetAlert(
      {
        title: "Iinvitation Sent !",
        subtitle: "The user has been notified.",
        success: true,
        timestamp: new Date().getTime(),
      },
      {
        confirm: {
          label: "Ok",
          level: "success",
        },
      }
    );
  }

  render() {
    const { classes } = this.props;
    const { index, name, id } = this.state;

    return (
      <Grid container className={classes.container} direction="column">
        <Grid
          item
          style={{
            height: "calc(100vh - 57px)",
            width: "100%",
            overflowY: "scroll",
            overflowX: "hidden",
            borderBottom: "solid 1px rgba(155, 155, 155, 0.3)",
          }}
        >
          <div
            style={{
              padding: 16,
              borderBottom: "solid 1px rgba(155, 155, 155, 0.3)",
            }}
          >
            <Grid container spacing={1}>
              <Grid item>
                <PublicTT fontSize="large" />
              </Grid>
              <Grid item>
                <Typography variant="h6">{name}</Typography>
                <Typography variant="caption" color="textSecondary">
                  #{id}
                </Typography>
              </Grid>
            </Grid>
          </div>
          {this.getStepContent(index)}
        </Grid>
        <Grid item>
          <BottomNavigation
            value={index}
            onChange={(event, newIndex) => {
              this.setState({ index: newIndex });
            }}
            showLabels
            className={classes.root}
          >
            <BottomNavigationAction label="General" icon={<Public />} />
            <BottomNavigationAction label="Users" icon={<People />} />
            <BottomNavigationAction label="Danger" icon={<Warning />} />
          </BottomNavigation>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(OrganizationDetail);
